var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 21.025V25.4451C26.75 26.1014 26.2426 26.6459 25.5881 26.6921C25.0414 26.7307 24.5954 26.75 24.25 26.75C13.2042 26.75 4.25 17.7958 4.25 6.75C4.25 6.40464 4.26931 5.95859 4.30794 5.41188C4.35421 4.75735 4.89867 4.25 5.55482 4.25H9.97513C10.296 4.25 10.5647 4.49303 10.5969 4.81225C10.6258 5.09884 10.6527 5.32892 10.6776 5.50252C10.9304 7.2684 11.4469 8.9492 12.1859 10.5038C12.3045 10.7533 12.2271 11.052 12.0023 11.2126L9.30444 13.1398C10.9469 16.9764 14.0236 20.0531 17.8602 21.6956L19.7839 19.0024C19.9465 18.7749 20.2487 18.6966 20.5012 18.8165C22.0557 19.5549 23.7364 20.0708 25.502 20.323C25.6745 20.3477 25.9031 20.3744 26.1877 20.4031C26.507 20.4354 26.75 20.7041 26.75 21.025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/phone-fill.a87403f8af78c2f26d5e700a2fd970fc.svg";
export { ForwardRef as ReactComponent };